import React from "react";
import { PieChart } from "react-minimal-pie-chart";

const PieDist = ({ pieData, colors, preset, sliders, previewLink }) => {
  const renderContent = () => {
    return (
      <div className="mint__dist">
        <h3
          className="mint-preview__title"
          style={{ color: "var(--primary-color)" }}
        >
          {preset}
        </h3>
        <div className="pie-wrapper">
          <PieChart
            className="pie"
            data={
              pieData.length > 0
                ? [
                    {
                      value: Math.round(pieData[0]),
                      color: colors.beneficiary_color,
                    },
                    {
                      value: Math.round(pieData[1]),
                      color: colors.artist_color,
                    },
                    {
                      value: Math.round(pieData[2]),
                      color: colors.sponsor_color,
                    },
                    /*{
                      value: Math.round(pieData[3]),
                      color: colors.seller_color,
                    },*/
                  ]
                : [
                    { value: 70, color: "#504C4C" },
                    { value: 15, color: "#918787" },
                    { value: 10, color: "#C7C2C0" },
                    /*{ value: 5, color: "#E5DFDD" },*/
                  ]
            }
            label={({ dataEntry }) =>
              dataEntry.value < 2
                ? ""
                : dataEntry.value >= 2 && dataEntry.value <= 3
                ? dataEntry.value
                : dataEntry.value + "%"
            }
            labelStyle={{ fontSize: "4px" }}
            startAngle={-90}
            labelPosition={87}
            radius={40}
            animate
          />
          <img src={previewLink} className="pie-nft" alt="pie-nft" />
        </div>
        <div className="pie-labels__wrapper">
          {sliders &&
            sliders.map((slider, index) => {
              return (
                <div key={slider.name} className="pie-label__wrapper">
                  <div
                    className="pie-label__color-box"
                    style={{ backgroundColor: slider.color }}
                  ></div>
                  <span className="pie-label">{slider.name}</span>
                </div>
              );
            })}
        </div>
      </div>
    );
  };
  return <React.Fragment>{renderContent()}</React.Fragment>;
};

export default PieDist;
